<app-spinner *ngIf="loading"></app-spinner>

<div class="wrapper">
  <h2 class="message" *ngIf="!loading">You have no authorized component</h2>
  <h5 class="message" *ngIf="!loading">Contact support for more information</h5>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/proxy/proxy.component.html